import { CardActionArea } from '@material-ui/core'

const initialState = {
	staffList: null,
	selectedStaff: null,
	loading: false,
	error: null
}

const team = (state = initialState, action) => {
	switch (action.type) {
		case 'RESET_APP':
			return { ...initialState }
		case 'GET_STAFF':
			return { ...state, loading: true }
		case 'GET_STAFF_SUCCESS':
			return { ...state, staffList: action.staffList, loading: false }
		case 'GET_STAFF_FAIL':
			return { ...state, loading: false, error: 'Error while fetching staff.' }
		case 'SET_SELECTED_STAFF':
			return { ...state, loading: false, selectedStaff: action.payload }
		case 'CLEAR_SELECTED_STAFF':
			return { ...state, selectedStaff: null }
		case 'UPDATE_STAFF':
			return { ...state, loading: true, selectedStaff: action.payload }
		case 'UPDATE_STAFF_SUCCESS':
			return { ...state, loading: false, selectedStaff: action.payload }
		case 'UPDATE_STAFF_FAIL':
			return { ...state, loading: false, error: action.payload }
		default:
			return state
	}
}

export default team
